import { Component, ReactNode } from "react";
import { StoryData, StoryNode } from "./StoryData";
import { Box } from "@mui/material";
import styled from "styled-components";
import { UIStyleConstants } from "../../rule-engine-core/Common/UIStyleConstants";
import { UILabel } from "../BuildlingBlocks/UILabel";
import { ObserveState } from "../StateManagement/ObserveState";
import { StateManager } from "../../rule-engine-core/Common/StateManager";

export class StoryView extends Component<{ node: StoryNode }> {
    state = {
        currentNodeId: "",
    };

    componentDidMount() {
        let params = new URLSearchParams(window.location.search);
        let currentNodeId = params.get("currentNodeId") || "";

        this.setState({
            currentNodeId: currentNodeId,
        });
    }

    render() {
        let currentNodeId = this.state.currentNodeId;

        return (
            <Box
                display={"flex"}
                flexDirection={"row"}
                height={"100%"}
            >
                <TreeViewRender>
                    <>
                        <UILabel variant={"large"}>AppGlue UI Stories</UILabel>
                        <Box>
                            {this.props.node.subNodes.map((n) => {
                                return this.RenderStoryNode(n, currentNodeId);
                            })}
                        </Box>
                    </>
                </TreeViewRender>
                <ObserveState
                    listenTo={this}
                    control={() => {
                        return (
                            <UIRender>
                                {currentNodeId !== "" &&
                                    StoryData.getStoryNode(currentNodeId) &&
                                    StoryData.getStoryNode(currentNodeId)!.render()}

                                {currentNodeId === "" ||
                                    ((StoryData.getStoryNode(currentNodeId) === undefined ||
                                        !StoryData.getStoryNode(currentNodeId)!.render()) && (
                                        <Box
                                            padding={"100px"}
                                            display={"flex"}
                                            justifyContent={"center"}
                                            alignContent={"center"}
                                        >
                                            <UILabel variant={"large"}>Select Story</UILabel>
                                        </Box>
                                    ))}
                            </UIRender>
                        );
                    }}
                />
            </Box>
        );
    }

    subNodeContains(node: StoryNode, selectedNodeId: string): boolean {
        if (node.id === selectedNodeId) return true;

        let subContains = false;

        if (node.subNodes) {
            for (let n of node.subNodes) {
                if (this.subNodeContains(n, selectedNodeId)) subContains = true;
            }
        }
        return subContains;
    }

    RenderStoryNode(node: StoryNode, selectedNodeId: string): ReactNode {
        let selected = node.id === selectedNodeId;
        let expanded = selected || this.subNodeContains(node, selectedNodeId);

        return (
            <Box
                key={node.id}
                display={"flex"}
                flexDirection={"column"}
                padding-top={"5px"}
                marginLeft={node.path.length === 1 ? "10px" : undefined}
            >
                <Box
                    padding={"3px"}
                    onClick={() => {
                        let params = new URLSearchParams(window.location.search);

                        if (params.has("currentNodeId")) {
                            params.delete("currentNodeId");
                        }

                        let id = node.id;

                        params.append("currentNodeId", id);

                        let newurl =
                            window.location.protocol +
                            "//" +
                            window.location.host +
                            window.location.pathname +
                            "?" +
                            params.toString();

                        window.history.pushState(undefined, "", newurl);

                        this.setState({
                            currentNodeId: id,
                        });

                        StateManager.changed(this);
                    }}
                >
                    <Box
                        bgcolor={selected ? UIStyleConstants.GRAY_VERY_LIGHT_COLOR : ""}
                        paddingTop={selected ? "2px" : ""}
                        paddingBottom={selected ? "2px" : ""}
                        borderBottom={selected ? "solid 2px " + UIStyleConstants.BLUE_COLOR : ""}
                        marginLeft={node.subNodes.length !== 0 ? "-15px" : undefined}
                    >
                        {node.subNodes && node.subNodes.length !== 0 && expanded && "- "}
                        {node.subNodes && node.subNodes.length !== 0 && !expanded && "+ "}
                        {node.name}
                    </Box>
                </Box>

                {expanded &&
                    node.subNodes.map((n) => {
                        return (
                            <Box
                                key={n.id + "Box"}
                                paddingLeft={"10px"}
                            >
                                {this.RenderStoryNode(n, selectedNodeId)}
                            </Box>
                        );
                    })}
            </Box>
        );
    }
}

const TreeViewRender = styled.div`
    border-left: solid 10px ${UIStyleConstants.GRAY_DARK_COLOR};
    border-top: solid 10px ${UIStyleConstants.GRAY_DARK_COLOR};
    border-bottom: solid 10px ${UIStyleConstants.GRAY_DARK_COLOR};
    padding: 10px;
    overflow: auto;
    min-width: 250px;
    height: 100%;
`;

const UIRender = styled.div`
    border: solid 10px ${UIStyleConstants.GRAY_DARK_COLOR};
    overflow: auto;
    padding: 10px;
    width: 100%;
    height: 100%;
`;
